export const planUsageHeatmapLegendRootSx = { px: 2, flexWrap: 'wrap', gap: 1.25 }

export const planUsageHeatmapLegendCaptionSx = {
  fontSize: '0.75rem',
  fontWeight: 510,
  lineHeight: '30px',
  color: 'text.secondary',
}

export const planUsageHeatmapLegendLabelSx = {
  fontSize: '0.875rem',
  fontWeight: 510,
  lineHeight: '30px',
  color: 'text.secondary',
}

export const planUsageHeatmapLegendSwatchSx = {
  width: 20,
  height: 20,
  borderRadius: '4px',
}

export const planUsageHeatmapLegendEmptySwatchSx = {
  ...planUsageHeatmapLegendSwatchSx,
  bgcolor: 'var(--app-heatmap-empty)',
}

export function planUsageHeatmapLegendLevelSwatchSx(color) {
  return {
    ...planUsageHeatmapLegendSwatchSx,
    bgcolor: color,
  }
}
